import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import { Container, HomeFornada } from "./styles";
import { URLBunge } from "../../Componentes/Config";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBDataTable,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
} from "mdbreact";
import Header from "../HeaderPortalVendedor";
import MenuPrinc from "../../Componentes/MenuPrinc";
import Carregando from "../../Componentes/Carregando";

const TOKEN = localStorage.getItem("c_token");
const EMAIL_USUARIO = localStorage.getItem("c_email");
var Tabela = {
  columns: [
    {
      label: "DATA CADASTRO",
      field: "dataCad",
      sort: "asc",
      width: 100,
    },
    {
      label: "NOME",
      field: "nome",
      sort: "asc",
      width: 100,
    },
    {
      label: "DATA NASCIMENTO",
      field: "dataNasc",
      sort: "asc",
      width: 100,
    },
    {
      label: "DDD",
      field: "ddd",
      sort: "asc",
      width: 100,
    },
    {
      label: "CELULAR",
      field: "celular",
      sort: "asc",
      width: 100,
    },
    {
      label: "EMAIL",
      field: "email",
      sort: "asc",
      width: 100,
    },
    {
      label: "STATUS",
      field: "statusDescricao",
      sort: "asc",
      width: 100,
    },
    {
      label: "REENVIAR TOKEN",
      field: "token",
      sort: "asc",
      width: 100,
    },
  ],
  rows: [],
};

class Home extends Component {
  state = {
    ListaSelect: {
      idProjeto: 2329681,
      nome: "",
      dataNasc: "",
      cpf: "",
      email: "",
      ddd: "",
      celular: "",
      origem: 597,
    },
    Lista: "",
    cnpj: "",
    codigoSap: "",
    razaoSocial: "",
    nomeFantasia: "",
    loading: false,
  };

  async componentDidMount() {
    this.carregaProp();
  }

  carregaProp = async () => {
    this.setState({ loading: true });
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var Prop = await fetch(
      `${URLBunge}/api/Cliente/BuscaPropPreCad/${2329681}`,
      requestOptions
    ).then((response) => response.json());

    let TabelaFull = Tabela;
    TabelaFull.rows = [];

    if (Prop.sucesso) {
      this.setState({ loading: false });
      this.setState({ Lista: {} });
      await Prop.preCadProprietario.forEach((pre) => {
        let dataNasc = pre.dataNasc.split("T");
        dataNasc = dataNasc[0].split("-").reverse().join("/");

        let dataCad = pre.dataCad.split("T");
        dataCad = dataCad[0].split("-").reverse().join("/");

        let email = pre.email;
        if (email != null || email != "") {
          email = pre.email;
        } else {
          email = " - ";
        }

        let descricao = pre.statusDescricao;

        TabelaFull.rows.push({
          dataCad: dataCad,
          cpf: pre.cpf,
          nome: pre.nome,
          dataNasc: dataNasc,
          celular: pre.celular,
          ddd: pre.ddd,
          email: email,
          statusDescricao: descricao,
          origem: 597,
          token:
            descricao === "Pré Cadastro" ? (
              <MDBBtn
                color="blue"
                size="sm"
                onClick={() => this.ReenviaToken(pre)}
              >
                Reenviar Token
              </MDBBtn>
            ) : (
              ""
            ),
        });
      });

      this.setState({ Lista: TabelaFull });
    } else {
      this.setState({ Lista: "", loading: false });
    }
  };

  toggle = (nr, pre) => {
    if (pre != null) {
      this.setState({ ListaSelect: pre });
    } else {
      this.setState({
        ListaSelect: {
          idProjeto: 2329681,
          nome: "",
          dataNasc: "",
          cpf: "",
          email: "",
          ddd: "",
          celular: "",
          origem: 597,
        },
      });
    }

    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  CadastrarProprietario = async () => {
    if (this.state.cnpj === "" || this.state.cnpj === null) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe o cpf ou Código SAP",
      });
      return;
    } else if (this.state.ListaSelect.cpf === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe o cpf",
      });
      return;
    } else if (this.state.ListaSelect.nome === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe o nome do proprietário",
      });
      return;
    } else if (this.state.ListaSelect.ddd === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe o ddd",
      });
      return;
    } else if (this.state.ListaSelect.celular === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe o celular",
      });
      return;
    } else if (this.state.ListaSelect.dataNasc === "") {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe o Data de nascimento",
      });
      return;
    }

    let cpf = this.state.ListaSelect.cpf.replace(/[.]/g, "");
    cpf = cpf.replace("-", "");

    let celular = this.state.ListaSelect.celular.replace("-", "");

    this.setState({ loading: true });
    var dados = {
      idProjeto: 2329681,
      loja: this.state.cnpj,
      nome: this.state.ListaSelect.nome,
      dataNasc: this.state.ListaSelect.dataNasc,
      cpf: cpf,
      ddd: this.state.ListaSelect.ddd,
      celular: celular,
      origem: this.state.ListaSelect.origem,
    };
    console.log("TESTE", dados);
    //return;

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      body: JSON.stringify(dados),
      headers: myHeaders,
      redirect: "follow",
    };
    var resSalva = await fetch(
      `${URLBunge}/api/Cliente/PreCadProprietario/`,
      requestOptions
    ).then((response) => response.json());

    if (resSalva.sucesso) {
      this.setState({ loading: false });
      Swal.fire({
        icon: "success",
        title: "Parabéns!",
        text: resSalva.data.mensagem,
      }).then(function () {
        window.location = "/Proprietario";
        //this.toggle(4);
        //this.carregaProp();
      });
    } else {
      this.setState({ loading: false });
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: resSalva.data.mensagem,
      });
    }
  };

  buscaLoja = async (e) => {
    const cnpj = this.state.cnpj;
    const codSap = this.state.codSap;

    if (cnpj !== "" && cnpj !== null) {
      //não faz nada
    } else {
      try {
        const dados = {
          idProjeto: 2329681,
          cnpj: cnpj,
          codSap: codSap,
        };

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "bearer " + TOKEN);
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
          method: "POST",
          body: JSON.stringify(dados),
          headers: myHeaders,
          redirect: "follow",
        };
        var Loja = await fetch(
          `${URLBunge}/api/Cliente/BuscaLoja`,
          requestOptions
        ).then((response) => response.json());
        this.setState({ loading: false });
        if (Loja.data.sucesso) {
          this.setState({ loading: false });
          this.setState({
            cnpj: Loja.data.cnpj,
            codSap: Loja.data.codigoSap,
            razaoSocial: Loja.data.razaoSocial,
            nomeFantasia: Loja.data.nomeFantasia,
          });
        } else {
          this.setState({ loading: false });
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: Loja.data.mensagem,
          });
          return;
        }
      } catch (e) {
        Swal.fire({
          icon: "info",
          title: "Atenção!",
          html: "Algum erro ocorreu por favor tente novamente.",
        });

        this.setState({ loading: false });
        return;
      }
    }
  };

  ReenviaToken = async (pre) => {
    var dados = {
      idProjeto: 2329681, //fornada
      nome: pre.nome,
      cpf: pre.cpf,
      ddd: pre.ddd,
      celular: pre.celular,
      tipo: 1,
    };
    this.setState({ loading: true });
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dados),
      redirect: "follow",
    };
    var Envia = await fetch(
      `${URLBunge}/api/Cliente/EnviaToken/`,
      requestOptions
    ).then((response) => response.json());
    if (Envia.sucesso) {
      this.setState({ loading: false });
      Swal.fire({
        icon: "success",
        title: "Tduo certo!",
        text: Envia.mensagem,
      }).then(function () {
        window.location = "/Proprietario";
      });
    } else {
      this.setState({ loading: false });
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: Envia.mensagem,
      });
    }
  };

  render() {
    return (
      <Container>
        <Header />
        <MenuPrinc/>
        {this.state.loading && <Carregando />}
        <HomeFornada>
          <div className="clear"></div>
          <div className="cadastros">
            <h1>Cadastro de Proprietário</h1>

            <div id="filtros">
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => {
                  this.toggle(4);
                }}
                style={{ float: "right" }}
              >
                Cadastrar Propritário
              </MDBBtn>
            </div>

            <div class="tabresp">
              <MDBDataTable
                striped
                bordered
                hover
                searchLabel="Pesquisar"
                paginationLabel={["Anterior", "Próximo"]}
                noRecordsFoundLabel="Nenhum resultado encontrado"
                infoLabel={["Mostrando", "de", "até", "registros"]}
                entriesLabel="Qtd por pagina"
                data={this.state.Lista}
              />
            </div>
          </div>

          <MDBModal
            isOpen={this.state.modal4}
            toggle={() => this.toggle(4)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(4)}>
              Pré-Cadastro Proprietário
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    <div className="campos50">
                      <label>Código SAP</label>
                      <input
                        type="text"
                        id="codSap"
                        className="form-control"
                        name="codSap"
                        value={this.state.codSap}
                        onChange={(e) => {
                          this.setState({ codSap: e.target.value });
                        }}
                        onBlur={() => this.buscaLoja()}
                        placeholder="Informe o código"
                      />
                    </div>

                    <div className="campos50">
                      <label>CNPJ</label>
                      <input
                        type="text"
                        id="cnpj"
                        className="form-control"
                        name="cnpj"
                        value={this.state.cnpj}
                        onChange={(e) => {
                          this.setState({ cnpj: e.target.value });
                        }}
                        onBlur={() => this.buscaLoja()}
                        placeholder="Ou Informe o CNPJ "
                      />
                    </div>

                    <div className="campos100">
                      <label>Razão Social</label>
                      <input
                        type="text"
                        id="razaoSocial"
                        className="form-control"
                        name="razaoSocial"
                        defaultValue={this.state.razaoSocial}
                        onChange={(e) => {
                          this.setState({ razaoSocial: e.target.value });
                        }}
                        placeholder="Razão Social"
                        readOnly
                      />
                    </div>

                    <div className="campos100">
                      <label>Nome Fantasia</label>
                      <input
                        type="text"
                        id="nomeFantasia"
                        className="form-control"
                        name="nomeFantasia"
                        defaultValue={this.state.nomeFantasia}
                        onChange={(e) => {
                          this.setState({ nomeFantasia: e.target.value });
                        }}
                        placeholder="Razão Social"
                        readOnly
                      />
                    </div>

                    <div className="campos50">
                      <label>CPF do proprietário</label>
                      <InputMask
                        mask="999.999.999-99"
                        maskChar=""
                        className="form-control"
                        type="text"
                        value={this.state.ListaSelect.cpf}
                        placeholder="Informe seu CPF"
                        onChange={(e) => {
                          var AdmUser = this.state.ListaSelect;
                          AdmUser.cpf = e.target.value;
                          this.setState({ ListaSelect: AdmUser });
                        }}
                      />
                    </div>

                    <div className="campos50">
                      <label>Nome</label>
                      <input
                        type="text"
                        id="nome"
                        className="form-control"
                        name="nome"
                        value={this.state.ListaSelect.nome}
                        onChange={(e) => {
                          var AdmUser = this.state.ListaSelect;
                          AdmUser.nome = e.target.value;
                          this.setState({ ListaSelect: AdmUser });
                        }}
                        placeholder="Informe o Nome"
                      />
                    </div>

                    <div className="campos50">
                      <label>Celular</label>
                      <div className="campos20">
                        <InputMask
                          name="ddd"
                          type="text"
                          id="ddd"
                          alt="#"
                          autoComplete="off"
                          size="2"
                          className="form-control"
                          value={this.state.ListaSelect.ddd}
                          onChange={(e) => {
                            var AdmUser = this.state.ListaSelect;
                            AdmUser.ddd = e.target.value;
                            this.setState({ ListaSelect: AdmUser });
                          }}
                          mask="99"
                        />
                      </div>
                      <div className="campos80">
                        <InputMask
                          name="celular"
                          id="celular"
                          type="text"
                          size="10"
                          alt="#"
                          autoComplete="off"
                          className="form-control"
                          value={this.state.ListaSelect.celular}
                          onChange={(e) => {
                            var AdmUser = this.state.ListaSelect;
                            AdmUser.celular = e.target.value;
                            this.setState({ ListaSelect: AdmUser });
                          }}
                          mask="99999-9999"
                        />
                      </div>
                    </div>

                    <div className="campos50">
                      <label>
                        Data de nascimento<em>*</em>
                      </label>
                      <InputMask
                        className="form-control"
                        name="dataNasc"
                        id="dataNasc"
                        alt="#"
                        type="text"
                        value={this.state.ListaSelect.dataNasc}
                        onChange={(e) => {
                          var AdmUser = this.state.ListaSelect;
                          AdmUser.dataNasc = e.target.value;
                          this.setState({ ListaSelect: AdmUser });
                        }}
                        mask="99/99/9999"
                        placeholder="99/99/9999"
                      />
                    </div>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="primary"
                size="sm"
                onClick={() => this.CadastrarProprietario()}
              >
                Salvar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>
        </HomeFornada>
      </Container>
    );
  }
}

export default withRouter(Home);
